/**
 * スタブページ（Coming soon 表示）
 *
 * 新メニュー構造に紐付くが、まだ実装されていないページで使用。
 * 親メニューにタブがある場合は TabBar も自動表示される。
 */
import PageHeader from "../components/PageHeader";
import { TabBar } from "../components/molecules/TabBar";
import { useMenuTitle } from "../shared/menu/useMenuTitle";
import { useCurrentTabs } from "../shared/menu/useMenus";

const ComingSoonPage = () => {
    const menuTitle = useMenuTitle();
    const { tabs } = useCurrentTabs();

    return (
        <div className="flex-1 flex flex-col overflow-hidden">
            <PageHeader title={menuTitle} />
            {tabs.length > 0 && <TabBar />}
            <div className="flex-1 flex items-center justify-center">
                <div className="text-center">
                    <p className="text-2xl font-medium text-gray-400">Coming soon</p>
                </div>
            </div>
        </div>
    );
};

export default ComingSoonPage;
